// Centralized color tokens for use in TypeScript (inline styles, components)
export const colors = {
  dwBg: '#0f1720', // deep charcoal for dark header
  dwAccent: '#c9a54a', // warm gold accent
  dwMuted: '#f5f5f5', // light text on dark backgrounds
  pageBg: '#f4f5f6', // light grey page background
  headerGradientTop: 'rgba(31, 45, 61, 0.95)',
  headerGradientBottom: 'rgba(15,23,32,0.9)',
  headerBorder: 'rgba(201,165,74,0.12)',
  headerShadow: '0 10px 30px rgba(15, 23, 32, 0.35)',
  titleTextShadow: '0 2px 8px rgba(0,0,0,0.6)'
} as const;

export const palette = {
    primary: {
        main: '#000000', // black
        contrastText: '#ffffff', // white
    },
    secondary: {
        main: '#ffffff', // white
        contrastText: '#000000', // black
    },
};

export default colors;
